import { createTheme } from '@cld/component-theme';
import defaultTheme from '@cld/themes';
import { globalThemeId } from '../utils/globalThemeId';

export const globalTheme = createTheme(defaultTheme, globalThemeId);
